import { h } from 'preact'
import { memo, useEffect } from 'preact/compat'
import { useRef } from 'preact/hooks'
import PropTypes from 'prop-types'
import { config } from '../../../config'
import styles from './Loader.module.scss'
import { isMobile } from '../../../helpers/common'

const DefaultLoader = () => (
  <div className={styles.loaderWrapper} data-testid="default-loader">
    <div className={styles.loaderBefore}></div>
    <div className={styles.loader}>Loading...</div>
    <div className={styles.loaderAfter}></div>
  </div>
)

export const mapLoaders = {
  BluePlane: 'assets/videos/Ani.mp4',
  WhitePlane: 'assets/videos/Ani_V3.mp4',
  MinimalistBluePlane: 'assets/videos/Ani_V2.mp4',
  MinimalistWhitePlane: 'assets/videos/Ani_ICONS.mp4',
}

const Loader = ({ loaderImage }) => {
  const loaderRef = useRef()
  const videoRef = useRef()

  const scrollToElement = () => {
    loaderRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }

  useEffect(() => {
    if (!videoRef?.current) return

    videoRef.current.addEventListener('loadeddata', scrollToElement, false)

    return () =>
      videoRef.current.removeEventListener('loadeddata', scrollToElement, false)
  }, [])

  return mapLoaders[loaderImage] && isMobile() ? (
    <div className={styles.videoLoader} ref={loaderRef}>
      <video autoPlay loop muted playsinline ref={videoRef} data-testid="video-element">
        <source
          data-testid="loader-source"
          src={`${config.baseURL}${mapLoaders[loaderImage]}`}
          type="video/mp4"
        />
      </video>
    </div>
  ) : (
    <DefaultLoader />
  )
}

Loader.propTypes = {
  loaderImage: PropTypes.string,
}

export default memo(Loader)
